<app-view-item *ngIf="readonly && selected" [text]="getProjectLabel(selected)" [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!readonly"
  #selector
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="false"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event, 20)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  (keydown)="handleKeyDown($event)"
  (click)="handleClick($event)"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  [nzDropdownRender]="renderTemplate"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <nz-option [nzValue]="-2" nzLabel="ALL : ALL PROJECT" *ngIf="!searching && !isProjectRestricted"></nz-option>
  <nz-option [nzValue]="-1" nzLabel="NO : NO PROJECT" *ngIf="!searching && !isProjectRestricted"></nz-option>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getProjectLabel(o)" nzCustomContent>
      <div class="dropdown-container">
        <strong>{{ o.code }}</strong>
        :
        <span> {{ o.name }}</span>
      </div>
    </nz-option>
  </ng-container>
</nz-select>

<ng-template #renderTemplate>
  <div class="text-center" *ngIf="!this.NotShowInReport && !isProjectRestricted">
    <button type="button" nz-button nzType="primary" (click)="addNew()">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
    </button>
  </div>
</ng-template>
